export default __webpack_public_path__ + "3522e836a4af403abf0a9a7d017438ff.png";